<div >
  <div style="width: 30em" id="card-info" #cardInfo></div>
</div>
<div id="card-errors" role="alert" *ngIf="error">{{ error }}</div>
